export const getAutoplay = (slider) => { /* eslint-disable-line import/prefer-default-export */
  const attr = 'data-glide-autoplay';
  const autoplay = slider.getAttribute(attr);
  if (autoplay) {
    return parseInt(autoplay, 10);
  }
  return 0;
};
